import { ToastService } from "@shared/lib/services";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { AI_WORKSPACE_QUERY_KEYS } from "../constants";
import { AiWorkspaceService } from "../services/aiWorkspace.service";
import { ISearchAIWorkspacePayload } from "../types";

export function useSearchAiWorkspace(payload: ISearchAIWorkspacePayload) {
  const { data, isLoading, isError, error, isFetching, refetch } = useQuery({
    queryKey: [AI_WORKSPACE_QUERY_KEYS.SEARCH, payload.pageNo, payload.limit, payload.name],
    queryFn: () => AiWorkspaceService.searchAIWorkspace(payload),
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    data,
    isFetching: isLoading,
    isFetchingOrig: isFetching,
    isError,
    refetch,
  };
}
